import React, { useCallback, useEffect, useState } from "react";
import { IoArrowRedoOutline } from "react-icons/io5";
import DealService from "../Services/DealService.js";
import { getIcons } from "../Constant/Constant.js";
import { showErrorToast } from "../Constant/Notification.js";
import { bookingPaymentType, paymentType } from "../../Enum.js";
import { useLocation, useNavigate } from "react-router-dom";
import Card from "./Card";
import DealInfoCard from "./DealInfoCard.jsx";
import SiteVisitHistoryCard from "./SiteVisitHistoryCard.jsx";
import DealHistoryCard from "./DealHistoryCard.jsx";
import DailyUpdateCommentCard from "./DailyUpdateCommentCard.jsx";
import ViewAdvanceAmountCard from "./ViewAdvanceAmountCard.jsx";
import AdminAppBar from "../adminComponents/AdminAppBar.jsx";

const PiplineUserDeals = ({ team, property }) => {
  const icons = getIcons();
  const [columns, setColumns] = useState([]);
  const location = useLocation();
//   pipline to userId
//   user info to userId 
  const userId = location.state?.userId;

  const userName = location.state?.userName;
  const userList = location.state?.userList || [];
  const navigate = useNavigate();
  
  // User data
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;
  
 
  const [loading, setLoading] = useState(false);
  const [dealID, setDealID] = useState("");
  const [dealInfoSelected, setDealInfoSelected] = useState(null);
  const [dealStageSelected, setDealStageSelected] = useState("");
  const [selectedDealData, setSelectedDealData] = useState(null);
  

  const [selectedDealCommentsList, setSelectedDealCommentsList] = useState([]);
  const [events, setEvents] = useState([]);
  const [sitevisitHistory, setSitevisitHistory] = useState([]);
  const [siteVisitImages, setSiteVisitImages] = useState([]);
  const [transactionData, setTransactionData] = useState([]);
  const [selectedPaymentType, setSelectedPaymentType] = useState([]);
  

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenModalSiteImages, setIsOpenModalSiteImages] = useState(false);


  const [activeView, setActiveView] = useState("default");
  const [previousView, setPreviousView] = useState("");


  const navigateTo = (view) => {
    setPreviousView(activeView);
    setActiveView(view);
  };


  const handleBack = () => {
    if (activeView !== "default" && activeView !== "dealInfo") {
      setActiveView(previousView);
      setPreviousView("");
    } else {
      navigate(-1);
    }
  };

  const fetchUserDealDetails = async () => {
    if (!userId) return;
    
    setLoading(true);
    try {
      const body = { uid: userId };
      const response = await DealService.fetchUserDeals(body);

      const formattedDeals = response.data.map((item) => {
        let status = "";
        if (!item?.scheduledTime) {
          status = "";
        } else if (
          new Date(item?.scheduledTime).getTime() > new Date().getTime()
        ) {
          status = "upcoming";
        } else {
          status = "no updates";
        }

        let day = "", time = "";
        if (item?.scheduledTime) {
          const dateObj = dateTimeConversion(item.scheduledTime);
          day = dateObj.dateMDY;
          time = dateObj.time;
        }

        return {
          id: item.id,
          squareFeet: `${item.squareFeet} Sq feet`,
          approx: "fixed",
          status: status,
          icon: "",
          customerName: item?.lead,
          siteName: item?.property,
          propertyId: item?.propertyId,
          stage: item?.currentStage,
          teamMemberName: item?.responsible,
          teamDetail: item?.team,
          teamId: item?.teamId,
          day: day,
          time: time,
          bookedTimestamp: item?.bookedTimestamp?._seconds
            ? Math.floor(
                (new Date() - new Date(item.bookedTimestamp._seconds * 1000)) /
                  (1000 * 60 * 60 * 24)
              )
            : "",
          recentComment: item?.lastComment?.comment,
        };
      });

      setColumns(formattedDeals);
    } catch (error) {
      console.log("Error in fetching user deal details", error);
    } finally {
      setLoading(false);
    }
  };

  // Date formatting helper function
  const dateTimeConversion = (timestamp) => {
    let dateMDY = "";
    let time = "";
    let date = new Date(timestamp);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const inputDate = new Date(date);
    inputDate.setHours(0, 0, 0, 0);

    if (inputDate.getTime() === today.getTime()) {
      dateMDY = "Today";
    } else if (inputDate.getTime() === yesterday.getTime()) {
      dateMDY = "Yesterday";
    } else {
      dateMDY = `${date.getDate()}-${
        date.getMonth() + 1
      }-${date.getFullYear()}`;
    }

    let hours = date.getHours();
    let minutes = String(date.getMinutes()).padStart(2, "0");
    let period = hours >= 12 ? "PM" : "AM";

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours -= 12;
    }

    time = `${String(hours).padStart(2, "0")}:${minutes} ${period}`;

    return { dateMDY, time };
  };

  useEffect(() => {
    fetchUserDealDetails();
  }, [userId]);

  // Show deal info handler
  const showDealInfo = async (taskData) => {
    try {
      const dealInfo = await DealService.showDealInfo(taskData.id);
      
      setDealID(taskData.id);
      setSelectedDealData(dealInfo.data);
      setSelectedDealCommentsList(dealInfo.data.commentsList);
      
      const dealData = dealInfo.data;
      
      // Format date for display
      if (dealData?.dealFollowup?.scheduledTime) {
        let date = new Date(dealData?.dealFollowup?.scheduledTime);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        
        let time = "";
        if (date.getHours() >= 12) {
          if (date.getHours() == 12) {
            time = `${String(date.getHours()).padStart(2, "0")}:${String(
              date.getMinutes()
            ).padStart(2, "0")} PM`;
          } else {
            time = `${String(date.getHours() - 12).padStart(2, "0")}:${String(
              date.getMinutes()
            ).padStart(2, "0")} PM`;
          }
        } else if (date.getHours() == 0) {
          time = `${String(12).padStart(2, "0")}:${String(
            date.getMinutes()
          ).padStart(2, "0")} AM`;
        } else {
          time = `${String(date.getHours()).padStart(2, "0")}:${String(
            date.getMinutes()
          ).padStart(2, "0")} AM`;
        }

        const formattedDate = `${day}-${month}-${year}, ${time}`;
        dealData.dealFollowup.scheduledTime = formattedDate;
      }

      setDealStageSelected(taskData?.stage);
      setDealInfoSelected(dealData);
      
      // Switch to deal info view
      navigateTo("dealInfo");
      
      // Fetch transaction data
      fetchTransactionData(taskData.id);
      
    } catch (error) {
      console.error("Error showing deal info:", error);
      showErrorToast("Failed to load deal information");
    }
  };

  // View handlers
  const handleOpenSiteVisitHistory = async () => {
    try {
      const response = await DealService.sitevisitHistory(dealID);
      const history = response.data.history.map((item) => ({
        responsible: item.responsible,
        property: item.property,
        timestamp: `${new Date(item.visitTime).toLocaleDateString(
          "en-GB"
        )} ${new Date(item.visitTime).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: true,
        })}`,
      }));
      setSitevisitHistory(history);
      navigateTo("siteVisitHistory");
    } catch (error) {
      showErrorToast(error.message);
    }
  };

  const handleDealHistory = async () => {
    try {
      const response = await DealService.dealHistory(dealID);
      const history = response.data.history.map((item) => ({
        log: item.log,
        timestamp: `${new Date(item.timeStamp).toLocaleDateString(
          "en-GB"
        )} ${new Date(item.timeStamp).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: true,
        })}`,
      }));
      setEvents(history);
      navigateTo("dealHistory");
    } catch (error) {
      console.error("Error fetching deal history:", error);
      showErrorToast("Failed to load deal history");
    }
  };

  const handleViewAdvanvcePayment = () => {
    navigateTo("advancePayment");
  };

  const handleDailyUpdateComment = () => {
    navigateTo("dailyUpdateComment");
  };

  const handleReport = () => {
    setIsOpenModal(true);
  };

  const handleViewSiteImages = async (dealId) => {
    try {
      const response = await DealService.fetchDealImages(dealId);
      if (response) {
        setSiteVisitImages(response?.data?.dealImages);
        setIsOpenModalSiteImages(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // Transaction data handlers
  const fetchTransactionData = async (id) => {
    try {
      const response = await DealService.showDealInfo(id || dealID);
      setTransactionData(response.data.advancePaymentList);
    } catch (err) {
      showErrorToast(err.message);
    }
  };

  const handleFilterPaymentType = (e) => {
    setSelectedPaymentType(e.target.value);
  };

  // Calculate financial summaries
  const filteredTransactions = transactionData.filter(
    (advancePayment) =>
      selectedPaymentType.length === 0 ||
      selectedPaymentType.includes(advancePayment.advanceAmountPaymentType)
  );

  // Calculate financial metrics for the deal
  const totalReceivedAmountOfPaymentType1 =
    selectedDealData?.advancePaymentList?.reduce((total, value) => {
      if (value?.paymentDefinition === 1) {
        return total + (value?.amountReceived || 0);
      }
      return total;
    }, 0) || 0;
    
  const totalReceivedAmountOfPaymentType2 =
    selectedDealData?.advancePaymentList?.reduce((total, value) => {
      if (value?.paymentDefinition === 2) {
        return total + (value?.amountReceived || 0);
      }
      return total;
    }, 0) || 0;
    
  const totalReceivedAmountOfPaymentType3 =
    selectedDealData?.advancePaymentList?.reduce((total, value) => {
      if (value?.paymentDefinition === 3) {
        return total + (value?.amountReceived || 0);
      }
      return total;
    }, 0) || 0;
    
  const totalReceivedAmount =
    totalReceivedAmountOfPaymentType1 -
    totalReceivedAmountOfPaymentType2 -
    totalReceivedAmountOfPaymentType3;

  const totalCostOfProperty = selectedDealData?.budget || 0;
  const totalCostOfPropertyWithRegistration =
    (selectedDealData?.budget || 0) +
    (selectedDealData?.registrationPayments?.totalRegistrationAmount || 0);
    
  let pendingAmount = totalCostOfPropertyWithRegistration - totalReceivedAmount;
  pendingAmount = pendingAmount > 0 ? pendingAmount : 0;

  let excessAmount =
    totalCostOfPropertyWithRegistration -
    totalReceivedAmount +
    totalReceivedAmountOfPaymentType2;
  excessAmount = excessAmount < 0 ? Math.abs(excessAmount) : 0;

  return (
    <div className="bg-appGrayBackground">
      <AdminAppBar />

      <div className="h-full py-20">
        {/* Header Section */}
        <div className="px-8 flex pt-4 gap-3 items-center">
          <div>
            <svg
              onClick={handleBack}
              className="cursor-pointer relative md:w-5 md:h-7 lg:w-5 lg:h-9"
              width="20"
              height="34"
              viewBox="0 0 22 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
                fill="#399E79"
              />
            </svg>
          </div>

          <div className="flex justify-between w-full">
            <div className="font-semibold md:mx-0 cursor-default lg:mx-6 md:text-xl mx-14 lg:text-4xl">
              Deal User {userName}
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row mx-4 md:mx-10 mt-6 gap-6 bg-white rounded-xl p-5 shadow-lg relative">
          {/* Left Panel - Deal List */}
          <div className="md:w-1/3 border border-gray-200 p-4 rounded-lg bg-gray-50 shadow-sm">
            <h2 className="text-lg font-semibold text-gray-700 mb-4">
              Total Deal {columns?.length}
            </h2>
            {!loading ? (
              <div className="flex flex-col gap-4 h-[800px] overflow-y-auto custom-scrollbar pr-2">
                {columns.map((task, index) => (
                  <div
                    key={task.id || index}
                    onClick={() => showDealInfo(task)}
                    className="cursor-pointer hover:bg-gray-100 transition-all p-2 rounded-lg"
                  >
                    <Card
                      title={task.lead}
                      task={task}
                      dealId={task.id}
                      index={index}
                    />
                    <hr className="w-full h-0.5 bg-gray-300 rounded mt-4" />
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex justify-center items-center h-full">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-customGreen"></div>
              </div>
            )}
          </div>

          <div className="hidden md:block w-[1px] bg-gray-300 mx-2"></div>

          <div className="w-full md:w-1/6 flex items-center justify-center text-gray-600 text-[50px] italic ">
            <IoArrowRedoOutline />
          </div>

          <div className="hidden md:block w-[1px] bg-gray-300 mx-2"></div>

          {/* Right Panel - Deal Details */}
          <div className="md:w-1/2 border border-gray-200 p-4 rounded-lg shadow-sm bg-white">
            {activeView === "default" ? (
              <div className="text-center text-gray-500 py-8">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-12 w-12 mx-auto text-gray-400 mb-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <p className="text-lg font-medium">
                  {"Please select a deal to view its details"}
                </p>
              </div>
            ) : activeView === "dealInfo" ? (
              <DealInfoCard
                icons={icons}
                dealID={dealID}
                userList={userList}
                onReload={() => {
                  setDealStageSelected("");
                  fetchUserDealDetails();
                  setActiveView("default");
                }}
                dealInfoSelected={dealInfoSelected}
                dealStageSelected={dealStageSelected}
                showDealInfo={showDealInfo}
                handleViewAdvanvcePayment={handleViewAdvanvcePayment}
                handleDailyUpdateComment={handleDailyUpdateComment}
                bookingPaymentType={bookingPaymentType}
                paymentType={paymentType}
                userRole={userRole}
                setIsOpenModal={setIsOpenModal}
                handleReport={handleReport}
                handleViewSiteImages={() => handleViewSiteImages(dealID)}
                handleOpenSiteVisitHistory={handleOpenSiteVisitHistory}
                handleDealHistory={handleDealHistory}
              />
            ) : activeView === "advancePayment" ? (
              <ViewAdvanceAmountCard
                handleFilterPaymentType={handleFilterPaymentType}
                selectedDealData={selectedDealData}
                handleAdvancePaymentBack={() => navigateTo("dealInfo")}
                selectedPaymentType={selectedPaymentType}
                bookingPaymentType={bookingPaymentType}
                totalCostOfProperty={totalCostOfProperty}
                totalReceivedAmount={totalReceivedAmount}
                pendingAmount={pendingAmount}
                excessAmount={excessAmount}
                totalReceivedAmountOfPaymentType3={totalReceivedAmountOfPaymentType3}
                dealStageSelected={dealStageSelected}
                filteredTransactions={filteredTransactions}
              />
            ) : activeView === "dailyUpdateComment" ? (
              <DailyUpdateCommentCard
                handleDailyUpdateCommentBack={() => navigateTo("dealInfo")}
                selectedDealCommentsList={selectedDealCommentsList}
              />
            ) : activeView === "dealHistory" ? (
              <DealHistoryCard
                events={events}
                handleDealHistoryBack={() => navigateTo("dealInfo")}
              />
            ) : activeView === "siteVisitHistory" ? (
              <SiteVisitHistoryCard
                sitevisitHistory={sitevisitHistory}
                handleCloseSiteVisitHistory={() => navigateTo("dealInfo")}
              />
            ) : null}
          </div>
        </div>
      </div>

    </div>
  );
};

export default PiplineUserDeals;